export default {
    indexSubGroups:         { method: 'get',    url: 'sub_groups'},
    storeSubGroup:          { method: 'post',   url: 'sub_groups'},
    updateSubGroup:         { method: 'put',    url: 'sub_groups/{id}'},
    destroySubGroup:        { method: 'delete', url: 'sub_groups/{id}'},
    updateSubGroupItems:    { method: 'post',   url: 'sub_groups/update_items'},
}